<template>
  <section class="products" aria-live="polite" id="product-results">
    <template v-if="filter">
      <h1>
        {{ filter.name }} Recommendations
      </h1>
      <div class="product-list" v-if="products">
        <div class="product" v-for="product in products" :key="product.gtin">
          <a :href="product.url" target="_blank">
            <img class="product-image" :src="product.imageUrl" alt="" />
            {{ product.title }}
          </a>
        </div>
      </div>
      <!-- TODO REMOVE ME -->
      <div class="product-list product-list--mock" v-if="debugging">
        <div class="product" v-for="product in productsMock" :key="product.gtin">
          <a :href="product.url" target="_blank">
            <img class="product-image" :src="product.imageUrl" alt="" />
            {{ product.title }}
          </a>
        </div>
      </div>
      <!-- -->
    </template>
  </section>
</template>

<script>

// {
//   "slug": "folgers-1850-16-ounce-pet-cup-1000-count-1000-count",
//   "gtin": "00025500000442",
//   "id": 797,
//   "title": "FOLGERS 1850 16 OUNCE PET CUP 1000 COUNT",
//   "imageUrl": "https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Global/image-thumb__1794__FeaturedItemTile/NoImageAvailable.jpg",
//   "url": "/brands/1850/product/folgers-1850-16-ounce-pet-cup-1000-count-1000-count",
//   "tags": [
//     "172",
//     "173",
//     "345",
//     "599",
//     "600",
//     "601",
//     "602",
//     "603",
//     "604",
//     "605",
//     "606",
//     "610",
//     "607",
//     "608",
//     "609"
//   ]
// }

export default {
  name: 'Products',
  data() {
    return {
      formatTagIds: {
        'fraction-pack': {
          tagID: '578',
          name: 'Fraction Pack'
        },
        'filter-pack': {
          tagID: '569',
          name: 'Filter Pack'
        },
        'whole-bean': {
          tagID: '72',
          name: "Whole Bean"
        },
        'roast-ground': {
          tagID: '43',
          name: 'Roast Ground',
        },
        'select-brew': {
          tagID: '73',
          name: 'Select Brew'
        }
      },
      brandTagIds: {
        'folgers': {
          tagID: '31',
          name: "Folgers"
        },
        '1850': {
          tagID: '345',
          name: '1850',
        },
        'cafe-bustelo': {
          tagID: '131',
          name: 'Cafe Bustelo',
        },
      },
      productsMock: [
        {
          gtin: '7447101014',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        },
        {
          gtin: '324',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        },
        {
          gtin: '234',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        },
        {
          gtin: '4',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        },
        {
          gtin: '744713201014',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        },
        {
          gtin: '74471201014',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        },
        {
          gtin: '7447101666014',
          url: '/brands/cafe-bustelo/product/bustelo-2-ounce-regular-fraction-pack-30-count-fraction-pack-30-count',
          imageUrl: 'https://s3.us-east-2.amazonaws.com/afh-www/site/tmp/image-thumbnails/AwayFromHome/Product/Image/image-thumb__2632__FeaturedItemTile/00074471010141_A1CB.JPG.jpg',
          title: 'Cafe Bustelo Espresso Coffee, 2 oz. Fraction Packs, 30/Case',
        }
      ]
    }
  },
  // watch: {
  //   brand(newValue, oldValue) {
  //     this.filterMode = 'brand'
  //     console.log(`Updating from ${oldValue} to ${newValue}`);
  //   },
  //   format(newValue, oldValue) {
  //     this.filterMode = 'format'
  //     console.log(`Updating from ${oldValue} to ${newValue}`);
  //   }
  // },
  computed: {
    filterMode() {
      return this.$store.state.filterMode
    },
    debugging() {
      return (process.env.NODE_ENV === 'development') ? true : false
    },
    format() {
      return this.$store.state.format
    },
    brand() {
      return this.$store.state.brand
    },
    filter() {
      // console.log('formatTagIds', this.format, this.formatTagIds[this.format])
      // console.log('brandTagIds', this.brand, this.brandTagIds[this.brand])
      if (this.filterMode === 'format') {
        return this.formatTagIds[this.format]
      } else if (this.filterMode === 'brand') {
        return this.brandTagIds[this.brand]
      } else {
        return { name: '' } // race condition? 
      }
    },
    products() {
      const allProducts = this.$store.state.products
      const filterID = this.filter.tagID
      // console.log('filterID: ', filterID)

      let products = allProducts.filter(function(product) {
        return product.tags.includes(filterID)
      })
      // console.dir('products', products)
      return products
    },
    persona() {
      return this.$store.state.results.personaCalculated
    }
  },
  // created() {
  //   // https://dev.to/viniciuskneves/watch-for-vuex-state-changes-2mgj
  //   this.unsubscribe = this.$store.subscribe((mutation, state) => {
  //   // this.unsubscribe = this.$store.subscribe((mutation, state) => {
  //     if (mutation.type === 'setFormat') {
  //       console.log(`Updating to ${state.format}`)
  //       // this.filterMode = 'format'
  //     } else if (mutation.type === 'setBrand') {
  //       console.log(`Updating to ${state.brand}`)
  //       // this.filterMode = 'brand'
  //     }
  //   })
  // },
  // beforeDestroy() {
  //   this.unsubscribe()
  // },
}
</script>

<style lang="scss">
.products {
  background-color: #F4F4F4;
  padding-bottom: 55px;
  h1 {
    font-size: 1.875em;
    text-align: center;
    font-weight: 900;
    text-transform: uppercase;
    color: #4FA0CA;
    margin: 0;
    padding: 40px 20px;
  }
  .product-list {
    max-width: $xxlarge;
    margin: 0 auto;
    padding: 0 1.875em;
    display: flex;
    flex-flow: row wrap;
    @supports (display: grid) {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(211px, 1fr));
      grid-gap: 1.5rem;
    }
  }
  .product {
    background-color: #fff;
    text-align: center;
    padding: 1em;
    border-radius: 5px;
    width: 48%;
    margin-right: 2%;
    margin-bottom: 2%;
    @supports (display: grid) {
      width: auto;
      margin: 0;
    }
    a {
      color: #6DAA3A;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 500;
    }
    @include breakpoint(large) {
      width: 21%;
      margin-right: 2%;
      margin-bottom: 2%;
      @supports (display: grid) {
        width: auto;
        margin: 0;
      }
    }
  }
  .product-image {
    width: 100%;
    height: auto;
    padding-bottom: 1em;
  }
}

</style>
